import HomeMenu from '../homemenu/homeMenu.vue';
import News from '../news/news.vue';
import Announcement from '../announcement/announcement.vue';
import CartableGrid from '../cartableGrid/cartableGrid.vue';

export default {
    components: {
        HomeMenu,
        News,
        Announcement,
        CartableGrid
    }
}
